export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "What are you looking for?",
    "back": "back",
    "Filtering": "Filtering",
    "Clear all": "Clear all",
    "Show more": "Show more",
    "Show less": "Show less",
    "Price": "Price",
    "to": "to",
    "Enter a correct value": "Enter a correct value",
    "Popularity": "Popularity",
    "Newest": "Newest",
    "Name (A-Z)": "Name (A-Z)",
    "Name (Z-A)": "Name (Z-A)",
    "Price (Ascending)": "Price (Ascending)",
    "Price (Descending)": "Price (Descending)",
    "Categories": "Categories",
    "Apply": "Apply",
    "No products were found in this category.": "No products were found in this category.",
    "More info": "More info",
    "Subscribe to our newsletter": "Subscribe to our newsletter",
    "Yes i subscribe!": "Yes i subscribe!",
    "Follow us": "Follow us",
    "Quick access to": "Quick access to",
    "Show store": "Show store",
    "In stock in {count} store(s)": "In stock in {count} store(s)",
    "Out of stock": "Out of stock",
    "In stock": "In stock"
}